import { WmsTransportDetailDto, WmsTransportHeaderDto } from "src/dtos/wmsTransport/wmsTransportDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface WMS1101_R01Dto {
	wmsOrderHeaderDto: WMS1101_R01HeaderDto;
	wmsOrderDetailDtoList: WMS1101_R01DetailDto[];
}

export interface WMS1101_R01HeaderDto extends WmsTransportHeaderDto {
	transportCode: string;
}

export const defaultWMS1101_R01HeaderDto: WMS1101_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	transportDt: formatDate(new Date()),
	inoutType: '',
	inoutClass: '',
	customCd: '',
	customNm: '',
	otherLogicCenter: '',
	inoutMethod: '',
	empNo: '',
	empNm: '',
	transAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	telNo: '',
	faxNo: '',
	email: '',
	post: '',
	address: '',
	otherAddress: '',
	trackingNo: '',
	approveFlg: '',
	remark: '',
	
	transportCode: '',

	inserted: false,
	isModified: false
}

export interface WMS1101_R01DetailDto extends WmsTransportDetailDto {
	locationCd?: string;
	locationNm?: string;
}

export const defaultWMS1101_R01DetailDto: WMS1101_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	transportNo: '',
	itemNo: '',
	compCd: '',
	compNm: '',
	logicCenter: '',
	transportDt: formatDate(new Date()),
	inoutType: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	unit: '',
	qty: 0,
	cost: 0,
	amt: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	remark: '',
	locationCd: '',
	locationNm: '',

	inserted: false,
	isModified: false
}
